<!--
 * @Author: gaoxueting
 * @Date: 2020-06-23 19:34:22
 * @LastEditTime: 2020-08-06 15:34:18
 * @LastEditors: fengzhongmei
 * @Description:
 * @FilePath: /rightcloud-console2/src/views/modules/cloudmgt/env/components/acl/cancelrelated.vue
-->
<template>
    <Modal v-model="operateDcs"
           :title="modalTitle"
           width="700">
        <div class="confirm-text">
            <Icon class="icon-explanation-1-o question-icon"></Icon>
            <div class="text">
                <p class="title">{{ title }}</p>
                <p class="desc">{{ desc }}</p>
            </div>
        </div>
        <Table border
               style="margin-left:72px;"
               :columns="columns"
               :data="tableData"></Table>
        <div slot="footer">
            <Button type="text"
                    class="ivu-btn-text"
                    @click="cancel">取消</Button>
            <Button type="primary"
                    :loading="loading"
                    @click="operate">
                <span>{{loading ? '保存中' : '确定'}}</span>
            </Button>
        </div>
    </Modal>
</template>

<script>
import API from '@/service/api.js'
export default {
    props: ['id', 'envId', 'envType', 'type'],
    data () {
        return {
            loading: false,
            operateDcs: false,
            rowData: null,
            modalTitle: '取消子网关联',
            title: '确定将该网络ACL的关联子网取消关联？',
            desc: '取消关联该子网后，其他网络ACL可以关联该子网。',
            columns: [{
                title: this.$t('名称'),
                key: 'networkName'
            }, {
                title: this.$t('网段'),
                key: 'cidr'
            }, {
                title: this.$t('私有网络'),
                key: 'vpcName'
            }],
            tableData: []
        }
    },
    methods: {
        openModal (rowData) {
            this.operateDcs = true
            this.rowData = rowData
            if (Object.prototype.toString.call(rowData) === '[object Object]') {
                this.tableData = [rowData]
            } else if (Object.prototype.toString.call(rowData) === '[object Array]') {
                this.tableData = rowData
            }
        },
        cancel () {
            this.operateDcs = false
        },
        operate () {
            this.loading = true
            this.axios.post(this.urlFormat(API.GET_ACL_DETACH_SUBNET, false), {
                cloudEnvId: this.envId,
                id: this.id,
                subnetId: this.rowData.id
            }).then(res => {
                if (res) {
                    this.loading = false
                    this.cancel()
                    this.$emit('refresh')
                    !res.message && this.$Message.info('操作成功')
                }
            })
        }
    }
}
</script>

<style lang="less" scoped>
.confirm-text {
    margin-bottom: 15px;
    .question-icon {
        font-size: 40px;
        color: #3498dc;
        vertical-align: top;
    }
    .text {
        display: inline-block;
        margin-left: 20px;
        p {
            line-height: 2;
        }
        .title {
            font-size: 14px;
            font-weight: bold;
            color: #333;
        }
        .desc {
            font-size: 12px;
            color: #666;
        }
    }
}
</style>
